import { render, staticRenderFns } from "./TenderResults.vue?vue&type=template&id=57743e20&scoped=true"
import script from "./TenderResults.vue?vue&type=script&lang=js"
export * from "./TenderResults.vue?vue&type=script&lang=js"
import style0 from "./TenderResults.vue?vue&type=style&index=0&id=57743e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57743e20",
  null
  
)

export default component.exports